import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { FlexLayoutModule} from '@angular/flex-layout';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import {  KeycloakAngularModule } from 'keycloak-angular';
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { ConnectionServiceModule } from 'ng-connection-service';  

import { AppRoutingModule } from './app-routing.module';
import { AngularMaterialModule } from './angular-material.module';
import { AppComponent } from './app.component';
import { DashboardContainerComponent } from './core-module/dashboard-container/dashboard-container.component';
import { KeycloakService } from './shared/auth-service/auth.service';
import { SecuredHttpInterceptor } from './shared/interceptor/http-error.interceptor';
import { FooterModule } from './authentication/registration/footer/footer.module';
import { AppConfig } from './core-module/app-config';


@NgModule({
  declarations: [
    AppComponent,
    DashboardContainerComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularMaterialModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    HttpClientModule,
    KeycloakAngularModule,
    ConnectionServiceModule,
    NgxUiLoaderModule,
    FooterModule,
    ToastrModule.forRoot({
      maxOpened: 2,
      autoDismiss: true,
      newestOnTop: true,
      preventDuplicates: true,
      timeOut: 5000,
      positionClass: 'toast-top-right',
      tapToDismiss: true,
      progressBar: true,
      disableTimeOut: false,
      closeButton: true
    })
  ],
  providers: [
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig], multi: true
    },
    { provide: APP_INITIALIZER, useFactory: kcFactory, deps: [KeycloakService], multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SecuredHttpInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
  exports: [AngularMaterialModule,FooterModule],
})
export class AppModule { }


export function kcFactory(keycloakService: KeycloakService) {
  return () => KeycloakService.init();
}

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}